define('plugin/line-liff/LineLiffPlugin',['require','lib/plugin/PluginAbstract','Config','lib/plugin/PluginBroker','lib/terms/ClientTermsController','plugin/line-liff/step/LineLiffClientLoginStep','plugin/line-liff/view/LineLiffFriendshipDialogView','plugin/line-liff/controller/LineLiffController','lib/theme/ThemeSettings','lib/AppRouter','lib/view/ModalRegion','lib/model/BaseModel'],function (require) {

    var PluginAbstract = require('lib/plugin/PluginAbstract');
    //var CookieBlock = require('cookieblock');
    var Config = require('Config');
    var PluginBroker = require('lib/plugin/PluginBroker');
    var ClientTermsController = require('lib/terms/ClientTermsController');

    var LineLiffClientLoginStep = require('plugin/line-liff/step/LineLiffClientLoginStep');
    var LineLiffFriendshipDialogView = require('plugin/line-liff/view/LineLiffFriendshipDialogView');
    var LineLiffController = require('plugin/line-liff/controller/LineLiffController');
    var ThemeSettings = require('lib/theme/ThemeSettings');
    var AppRouter = require('lib/AppRouter');
    var ModalRegion = require('lib/view/ModalRegion');
    var BaseModel = require('lib/model/BaseModel');

    var SCOPES = ["profile", "openid", "phone", "email", "chat_message.write"];

    return PluginAbstract.extend({

        _collection: null,
        _clientModel: null,
        _termsController: null,

        liff: null,
        _step: null,
        _isLiffReady: false,
        _skipPageUrl: '',
        _skipStepPage: false,
        isFriendshipChecked: false,

        initialize: function () {
            var _this = this;
            this.initModel();
            this.initRoutes();

            this._termsController = ClientTermsController.getInstance({
                'client': this._clientModel
            });

            var liffId = Config.getInstance().getOption('line_liff_id');

            if(liffId) {
                if(window.define) {
                    window.define.amd = null;
                }
                requirejs(['line_liff'], _.bind(this._initLineLiff, this));
            }

            _this.onLiffApiReady(function (){
                if(_this._isLiffLoggedIn()){
                    _this._loginByToken();
                    _this._checkFriendship();
                }

                if (!_this._isAllowedUrl()) {
                    // Backbone.history.navigate('book', {
                    //     trigger: true,
                    //     //replace: true
                    // });
                }
            });

            Backbone.Wreqr.radio.channel('page').vent.on(
                'render', _.bind(this._addBeforeClientView, this)
            );

            Backbone.Wreqr.radio.channel('client_login').vent.on('client:signin', function () {
                _this._skipStepPage = false;
            });
            Backbone.Wreqr.radio.channel('client_login').vent.on('client:signout', function () {
                _this._skipStepPage = false;
                _this.liff.logout();
            });

            if ("localStorage" in window) {
                if(window.localStorage.getItem("line_skip_page_url")){
                    this._skipPageUrl = window.localStorage.getItem("line_skip_page_url");
                    window.localStorage.removeItem("line_skip_page_url");
                }
            }

            // Backbone.Wreqr.radio.channel('client_login').vent.on(
            //     'client:signin', _.bind(this._reloadFieldsCollection, this)
            // );
            // Backbone.Wreqr.radio.channel('client_login').vent.on(
            //     'client:signout', _.bind(this._reloadFieldsCollection, this)
            // );
            // Backbone.Wreqr.radio.channel('client_login').vent.on(
            //     'client:idchanged', _.bind(this._reloadFieldsCollection, this)
            // );
        },

        initStepManagerEvents: function () {
            var _this = this;


            this.listenTo(Config.getInstance(), 'config:changed', function(){
                if (Config.getInstance().getOption('widget_url')) {
                    _this._checkWidgetAuth();
                    //stop listening
                    _this.stopListening(Config.getInstance(), 'config:changed');
                }
            });
        },

        _checkWidgetAuth: function () {
            if(this._isIframe()) {
                var pageUrl = null;
                var widgetUrl = window.location.href;
                //console.log(Config.getInstance().getOption('widget_url'));
                if (Config.getInstance().getOption('widget_url')) {
                    widgetUrl = Config.getInstance().getOption('widget_url');
                }
                var gparams = this.parseGetParams(widgetUrl);

                if(gparams['code'] && gparams['state']) {
                    if ("localStorage" in window) {
                        if (window.localStorage.getItem("line_liff_current_url")) {
                            pageUrl = window.localStorage.getItem("line_liff_current_url");
                            window.localStorage.removeItem("line_liff_current_url");
                        }
                    }
                    if(!pageUrl) {
                        return;
                    }

                    //add code and state params to page url and save current url params and hash
                    var pageUrlParams = this.parseGetParams(pageUrl);
                    var pageUrlWithoutParams = pageUrl.split('?')[0];
                    var pageUrlHash = pageUrl.split('#')[1];
                    var liffIdData = String(Config.getInstance().getOption('line_liff_id')).split('-');
                    var lredirectUri = pageUrl;

                    if ("localStorage" in window) {
                        lredirectUri = window.localStorage.getItem("line_liff_redirect_uri");
                    }

                    // the default page first, otherwise liff.state becomes '#undefined'
                    if(!pageUrlHash) {
                        pageUrlHash = 'book';
                    }

                    gparams['liff.state'] = '#'+pageUrlHash;
                    gparams['liffRedirectUri'] = lredirectUri;
                    gparams['liffClientId'] = liffIdData?liffIdData[0]:Config.getInstance().getOption('line_liff_id');

                    //console.log(gparams, pageUrl, pageUrlHash);

                    var allparams = _.extend(pageUrlParams, gparams);
                    var newPageUrl = pageUrlWithoutParams + '?' + $.param(allparams) + '#' + pageUrlHash;

                    //console.log(newPageUrl);

                    window.location.replace(newPageUrl);
                }
            }
        },

        _showClientLoginPage: function () {
            var _this = this;

            var currentUrl = Backbone.history.getFragment();
            this._skipPageUrl = currentUrl;

            if ("localStorage" in window) {
                window.localStorage.setItem("line_skip_page_url", this._skipPageUrl);
            }

            var redirectUrl = currentUrl.replace('client/', 'line/');

            Backbone.history.navigate(redirectUrl, {
                trigger: true,
                //replace: true
            });
        },

        _addBeforeClientView: function (data) {
            var _this = this;
            if(!this._showClientLoginPageDebounce) {
                this._showClientLoginPageDebounce = _.debounce(this._showClientLoginPage, 300);
            }

            if (data.page == 'client_login') {
                this.onLiffApiReady(function () {
                    var currentUrl = Backbone.history.getFragment();
                    if (currentUrl.indexOf('client/sign-in') === 0 && !_this._skipStepPage) {
                        _this._showClientLoginPageDebounce();
                    }
                });
            }
        },

        /**
         * Initialize client model
         */
        initModel: function () {
            var _this = this;
            this._clientModel = this.getOption('clientModel');

            //this.listenTo(this._clientModel, 'sync', this.checkIfClientLoggedIn);
        },

        /**
         * Inits client login routes
         */
        initRoutes: function () {

            this._controller = new LineLiffController({
                app: this.getOption('app'),
                clientModel: this._clientModel,
                signInModel: this._signInModel,
                handler: this
            });

            var clientRouter = new AppRouter({
                appRoutes: {
                    'line/sign-in(/back/:back)(/message/:message)(/)': 'signIn',
                    'context_token=(:context)': 'lineContext',
                    'access_token=(:context)': 'lineContext',
                },
                menuItem: 'line_liff',
                controller: this._controller
            });
        },

        onLiffApiReady: function(handler){
            if(this._isLiffReady) {
                handler();
            } else {
                this.listenTo(this,'liff:ready', _.bind(handler, this));
            }
        },

        getClientModel: function () {
            return this._clientModel;
        },

        _initLineLiff : function (liff){
            var _this = this;
            this.liff = liff;

            liff.init({
                liffId: Config.getInstance().getOption('line_liff_id'),
                withLoginOnExternalBrowser: false, // Enable automatic login process
            }).then(function(){
                // start to use LIFF's api
                // console.log(liff.getLanguage());
                // console.log(liff.getVersion());
                // console.log(liff.isInClient());
                // console.log(liff.isLoggedIn());
                // console.log(liff.getOS());
                // console.log(liff.getLineVersion());
                _this._isLiffReady = true;
                _this.trigger('liff:ready');

                if(_this.liff.isLoggedIn()){
                    setTimeout(function(){
                        _this._checkFriendship();
                    }, 7000);
                }

            }).catch(function(err){
                console.log('LIFF ID', Config.getInstance().getOption('line_liff_id'));
                console.log('Error LIFF', err);
                _this.trigger('liff:ready');
            });
        },

        _isAllowedUrl : function () {
            var allowedUrls = ['line', 'book', 'client/', 'bonus', 'membership', 'contact', 'gift-card'];
            var currentUrl = Backbone.history.getFragment();

            if(!currentUrl || String(currentUrl).length === 0){
                return true;
            }

            var isAllowedUrl = false;
            _.each(allowedUrls, function (url) {
                if (currentUrl.indexOf(url) === 0) {
                    isAllowedUrl = true;
                }
            });
            return isAllowedUrl;
        },

        /**
         * On sign in validate login data and try to login on server
         *
         * @param data
         */
        performSignIn: function (data) {
            this.resetErrors();

            var termsValid = this.getTermsController().validate();

            if (termsValid){
                if(this._isLiffLoggedIn()){
                    this._loginByToken();
                    this._checkFriendship();
                } else {
                    this._saveAcceptedClientData();
                    var options ={
                        redirectUri: window.location.href,
                        scopes: SCOPES,
                    };
                    if(Config.getInstance().getOption('line_liff_friendship')){
                        options.bot_prompt = "aggressive";
                    }
                    if(this._isIframe()){
                        this._loginManual(options);
                    } else{
                        this.liff.login(options);
                    }
                    //remove cookie
                    $.removeCookie('line_liff_login', {path: '/'}); // NB jquery.cookie 1.4: $.cookie(name, null) writes 'null'
                }
            }
        },

        _isIframe: function(){
            return (window.location != window.parent.location);
        },

        _loginManual: function(options){
            if (!("localStorage" in window)) {
                alert("This browser does not support localStorage. This authentication method will not work. Please enable localStorage or use a different browser.");
                return;
            }

            var _this = this;
            var url = 'https://access.line.me/oauth2/v2.1/authorize';
            var redirectURL = (window.location != window.parent.location)
                ? document.referrer
                : document.location.href;

            if(Config.getInstance().getOption('widget_url')){
                redirectURL = Config.getInstance().getOption('widget_url');
            }

            var liffIdData = String(Config.getInstance().getOption('line_liff_id')).split('-');
            var clientId = liffIdData?liffIdData[0]:Config.getInstance().getOption('line_liff_id');

            localStorage.setItem('line_liff_redirect_uri', redirectURL);

            var params = {
                response_type: 'code',
                client_id: clientId,
                app_id: Config.getInstance().getOption('line_liff_id'),
                redirect_uri: redirectURL,
                state: this._generateUniqueState(),
                liff_sdk_version: this.liff.getVersion(),
                code_challenge_method: 'S256',
            };



            if(options){
                //prepare params
                _.each(options, function(value, key){
                    switch (key) {
                        case 'redirectUri':
                            options.redirect_uri = value;
                            //unset redirect uri
                            delete options.redirectUri;
                            break;

                        case 'scopes':
                            options.scope = _.isArray(value) ? value.join(' ') : value;
                            //unset scopes
                            delete options.scopes;
                            break;

                        case 'bot_prompt':
                            //unset bot_prompt
                            delete options.bot_prompt;
                            break;
                    }
                });

                params = _.extend(options, params);
            }
            var codeVerifier = this._randomAlphaNumericString(43);

            this._generateCodeChallenge(codeVerifier, function (codeChallenge) {

                params.code_challenge = codeChallenge;
                var query = jQuery.param(params);
                var fullUrl = url + '?' + query;

                if ("localStorage" in window) {
                    localStorage.setItem('line_liff_current_url', window.location.href);
                }
                //redirect to line login
                _this._redirectParentWindow(fullUrl);
            });

        },

        _generateCodeChallenge: function(code_verifier, handler){
            var _this = this;
            if ("localStorage" in window) {
                localStorage.setItem('line_liff_code_verifier', code_verifier);
                //LIFF_STORE:{LIFF_ID_WITH_DEFIS}:loginTmp - hack for backward compatibility
                localStorage.setItem('LIFF_STORE:'+Config.getInstance().getOption('line_liff_id')+':loginTmp', JSON.stringify({
                    codeVerifier: code_verifier,
                }));
                //remove old context
                localStorage.removeItem('LIFF_STORE:'+Config.getInstance().getOption('line_liff_id')+':context');
            }
            return this.generateSHA256Hash(code_verifier).then(function(hash){
                handler( _this._base64HEX(hash));
            });
        },

        // Encode Hexadecimal to Base64
        _base64HEX: function (inputHex) {
            return btoa(
                inputHex.match(/.{1,2}/g).map(function (byte) {
                    return String.fromCharCode(parseInt(byte, 16));
                }).join('')
            ).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
        },

        // generate sha256 hash from string in base64
        generateSHA256Hash: function (text) {
            var  encoder = new TextEncoder();
            var  data = encoder.encode(text);

            return crypto.subtle.digest('SHA-256', data).then(function(hashBuffer) {
                var hashArray = Array.from(new Uint8Array(hashBuffer));
                var hashHex = hashArray.map(function(byte) {
                    return byte.toString(16).padStart(2, '0');
                }).join('');
                return hashHex;
            }).catch(function(err) {
                console.error(err);
            });
        },

        _redirectParentWindow: function(url){
            window.top.location.href = url;

            setTimeout(function(){
                window.location.href = url;
            }, 3000);
        },

        //generate unique state 12 symbols
        _generateUniqueState: function(){
            var state = this._randomAlphaNumericString(12);
            if ("localStorage" in window) {
                localStorage.setItem('line_liff_state', state);
            }
            return state;
        },

        _randomAlphaNumericString: function(length) {
            var chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
            var result = '';
            for (var i = length; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)];
            return result;
        },

        skipStepPage: function (){
            var _this = this;
            this._skipStepPage = true;

            if(!this._skipPageUrl){
                this._skipPageUrl = 'client/sign-in';
            }

            Backbone.history.navigate(this._skipPageUrl, {
                trigger: true,
                //replace: true
            });
        },

        skipStep: function (){
            if(this._step){
                this._step.skipStep();
            }
        },

        resetErrors: function () {
            this._clientModel.validationError = null;
        },

        _loginByToken: function(){
            var _this = this;
            if(this._isLiffLoggedIn()){
                var token = this.liff.getIDToken();
                var clientData = this.liff.getDecodedIDToken();

                var data = _.extend({
                    'line_id_token': token,
                    'line_client_id': clientData.sub,
                }, this.getAcceptedClientData());

                this._clientModel.set(data);
                this._clientModel.loginByLineIdToken(data, function(){
                    if(_this._step){
                        _this._step.done();
                    }
                }, function(){
                    // Login failed — stay on LINE login step, user can retry
                });
            }
        },

        getAcceptedClientData: function(){
            if(!_.isUndefined(localStorage) && localStorage.getItem('accepted_client_data')){
                var terms = JSON.parse(localStorage.getItem('accepted_client_data'));
                localStorage.removeItem('accepted_client_data');
                return terms;
            } else{
                return {
                    'terms': this.getTermsController().getModel().getAcceptedTerms(),
                };
            }
        },
        
        _saveAcceptedClientData: function(){
            var _this = this;
            if(!_.isUndefined(localStorage)) {
                _.each(_.keys(localStorage), function (key, value) {
                    if (key.indexOf('LIFF_STORE') === 0) {
                        localStorage.removeItem(key);
                    }
                });

                localStorage.setItem('accepted_client_data', JSON.stringify({
                    'terms': _this.getTermsController().getModel().getAcceptedTerms(),
                }));
            }
        },

        _isLiffLoggedIn : function(){
            if(this.liff.isLoggedIn()){
                var clientData = this.liff.getDecodedIDToken();
                if(!clientData){
                    return false;
                }
                var nowTime = Math.floor(Date.now() / 1000);
                var expTime = parseInt(clientData.exp);

                if(nowTime > expTime){
                    return false;
                }
                return true;
            }
            return false;
        },

        _isLiffSite : function(){
            if (ThemeSettings.getInstance().getOption('widget_type') === 'line') {
                return true;
            }
            if(this._isLiffReady && this.liff.isInClient()){
                return true;
            }
            return false;
        },

        _checkFriendship : function(){
            if(this.isFriendshipChecked){
                return;
            }
            if($.cookie('line_liff_friendship')){
                return;
            }
            if(parseInt(Config.getInstance().getOption('line_liff_friendship'))){
                var _this = this;

                this.isFriendshipChecked = true;
                this.liff.getFriendship().then(function(data){
                    if(!data.friendFlag){
                        _this._showFriendshipPopup();
                    } else {
                        _this._subscribeCallback();
                    }
                }).catch(function(err){
                    console.log(err);
                });
            }
        },

        _subscribeCallback: function(){
            var _this = this;
            if(this.liff.isLoggedIn()) {
                var clientData = this.liff.getDecodedIDToken();
                var data = {
                    'line_client_id': clientData.sub,
                    'line_id_token': this.liff.getIDToken(),
                };
                var subscribeUrl = '/v2/bot/linebot/';
                $.ajax({
                    url: subscribeUrl,
                    type: 'POST',
                    data: data,
                    success: function (response) {

                    }
                });
            }
        },

        _showFriendshipPopup : function(){
            var subscribeUrl = 'https://access.line.me/oauth2/v2.1/authorize';
            var liffId = String(Config.getInstance().getOption('line_liff_id'));
            var subscribeUrlParams = {
                response_type: 'code',
                client_id: liffId.split('-')[0],
                redirect_uri: window.location.href,
                scope: SCOPES.join(' '),
                bot_prompt: 'aggressive',
                state: 'subscribe',
            };
            subscribeUrl += '?' + $.param(subscribeUrlParams);

            if(Config.getInstance().getOption('line_liff_account_name')){
                subscribeUrl = 'https://line.me/R/ti/p/@' + String(Config.getInstance().getOption('line_liff_account_name')).replace('@', '');
            }

            var region = new ModalRegion();
            var dialog = new  LineLiffFriendshipDialogView({
                model: new BaseModel({
                    liffId: Config.getInstance().getOption('line_liff_id'),
                    scopes: SCOPES,
                    subscribeUrl: subscribeUrl,
                })
            });
            region.show(dialog);

            this.listenTo(dialog, 'confirm', function (){
                window.open(subscribeUrl, '_blank');
            });
            this.listenTo(dialog, 'cancel', function (){
                $.cookie('line_liff_friendship', '1', { expires: 365, path: '/' });
            });
        },


        /**
         * Adds client registration/login step before client details.
         * It will show only if user is not logged in.
         *
         * @param Array steps
         * @return Array|null
         */
        modifySteps: function (steps) {
            if(this._isLiffSite()) {
                var index = _.indexOf(steps, 'client-login');
                if (index < 0) {
                    index = _.indexOf(steps, 'details');
                }
                steps.splice(index, 0, 'line-liff');
            }
            return steps;
        },

        /**
         * Returns plugin step object
         *
         * @see lib/controller/booking/BaseStep
         * @param String step - step name
         * @param Object params - step parameters
         * @return BaseStep|null
         */
        getStep: function (step, params) {
            if (step === 'line-liff') {
                this._step = new LineLiffClientLoginStep(_.extend({}, params, {
                    clientModel: this._clientModel,
                    //signInModel: this._signInModel,
                    handler: this
                }));

                return this._step;
            }
        },

        getTermsController: function () {
            return this._termsController;
        },

        parseGetParams : function (url) {
            if(!url){
                url = window.location.href;
            }
            var query = url.split('?')[1];
            if(!query){
                return {};
            }
            var params = {};
            var vars = query.split('&');
            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split('=');
                params[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
            }
            return params;
        }

    });

});

